/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Get_Help_Or_Browse_FaqInputs */

const en_mobile_get_help_or_browse_faq = /** @type {(inputs: Mobile_Get_Help_Or_Browse_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat with support or send us an email`)
};

const es_mobile_get_help_or_browse_faq = /** @type {(inputs: Mobile_Get_Help_Or_Browse_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatea con soporte o envíanos un correo`)
};

/**
* | output |
* | --- |
* | "Chat with support or send us an email" |
*
* @param {Mobile_Get_Help_Or_Browse_FaqInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_get_help_or_browse_faq = /** @type {((inputs?: Mobile_Get_Help_Or_Browse_FaqInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Get_Help_Or_Browse_FaqInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_get_help_or_browse_faq(inputs)
	return en_mobile_get_help_or_browse_faq(inputs)
});